<template>
  <el-container class="style1" id="region" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <!--  -->
    <el-dialog title="添加专辑组" :visible.sync="dialogVisible1" v-if="isshow" width="40%" :close-on-click-modal="false"
      :before-close="handleClose">
      <span>
        <el-form v-if="isshow" :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup1"
          :model="addgroup">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="简要说明" prop="explan">
            <el-input v-model="addgroup.explan" rows="3" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
          <!-- <el-form-item label="学术资料" prop="academic" style="padding-bottom:20px">
            <el-select v-model="academicvalue" placeholder="请选择">
              <el-option v-for="item in academicfile" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup1');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm1('addgroup1')">确 定</el-button>
        <!-- <el-button type="primary" @click="groupsave(addgroup1)">确 定</el-button> hello-->
      </span>
    </el-dialog>

    <el-dialog title="编辑专辑组" :visible.sync="dialogVisible2" width="40%" :close-on-click-modal="false">
      <span>
        <el-form :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup2" :model="addgroup">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="简要说明" prop="explan">
            <el-input v-model="addgroup.explan" rows="3" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup2');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm2('addgroup2')">确 定</el-button>
        <!-- <el-button type="primary" @click="saveeditgroup()">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-dialog title="添加专辑" :visible.sync="dialogVisible3" width="40%" :close-on-click-modal="false" v-if="isshow">
      <span>
        <el-form v-if="isshow" :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup3"
          :model="addgroup">
          <el-form-item label="专辑组" prop="title">
            <el-input v-model="this.righttitle" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="简要说明" prop="explan">
            <el-input v-model="addgroup.explan" rows="3" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup3');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm3('addgroup3')">确 定</el-button>
        <!-- <el-button type="primary" @click="saveAlbum()">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-dialog title="编辑专辑" :visible.sync="dialogVisible4" width="40%" :close-on-click-modal="false">
      <span>
        <el-form :label-position="labelPosition" label-width="125px" :rules="rules" ref="addgroup4" :model="addgroup">
          <el-form-item label="专辑名称" prop="name">
            <el-input v-model="addgroup.name"></el-input>
          </el-form-item>
          <el-form-item label="简要说明" prop="explan">
            <el-input v-model="addgroup.explan" rows="3" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input v-model.number="addgroup.sort"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
            resetForm('addgroup4');
            canclefun();
          ">取 消</el-button>
        <el-button type="primary" @click="submitForm4('addgroup4')">确 定</el-button>
        <!-- <el-button type="primary" @click="editAlbum()">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-header>
      <el-row style="border-bottom: 2px dashed #dcdfe6;padding-bottom: 10px;">
        <el-col style="font-size: 20px; font-weight: bold;padding-bottom: 10px;">专辑管理</el-col>
      </el-row>
      <el-row style="display:flex;padding-top: 5px;"> </el-row>
    </el-header>
    <el-container style="padding:0">
      <el-aside style="display:flex;flex-direction:column;background-color:white;">
        <el-col class="flex2" style="padding:10px 0">
          <div style="font-weight:bold">专辑组</div>
          <el-button icon="el-icon-plus" type="primary" size="small" @click="addgroup2()">添加</el-button>
          <!-- 添加专辑组 -->
        </el-col>
        <div class="formstyle" :style="{ 'max-height': this.timeLineHeight + 'px' }">
          <el-row v-for="(item, index) in albumList" :key="index" class="cellstyle"
            @click.native="clickleft(item, index)" :class="activnum === index ? 'success-text' : ''">
            <div style="display: flex;">
              <div :class="activnum === index ? 'leftdiv' : ''"></div>
              <div style="flex:1">
                <el-col class="flex2 paddingleft">
                  <div style="font-size:small;font-weight:bold">{{ item.title }}</div>
                  <div class="flex1" style="align-items: center;">
                    <el-button type="text" @click="editgroup(item)" style="font-size:small">编辑</el-button>
                    <!-- 编辑专辑组 -->
                    <div style="color:#dadada;padding: 0 3px;">|</div>
                    <!-- 删除专辑组 -->
                    <el-button type="text" @click="delategroup(item)" style="font-size:small;color: #D03328;">删除
                    </el-button>
                  </div>
                </el-col>
                <el-col class="paddingleft-b">
                  <span class="tags">{{ item.sub_title }}</span>
                </el-col>
              </div>
            </div>
          </el-row>
        </div>
      </el-aside>
      <el-main style="display:flex;flex-direction:column ;padding-left:20px">
        <el-col class="flex2" style="padding: 10px 0;">
          <div style="font-weight:bold">{{ this.righttitle }}</div>
          <div>
            <el-button :disabled="albumList.length===0" icon="el-icon-plus" type="primary" size="small"
              @click="addalbum()">添加</el-button>
          </div>
          <!-- 添加专辑 -->
        </el-col>
        <div class="formstyle" :style="{ 'max-height': this.timeLineHeight + 'px' }" style="padding-left:10px;">
          <el-row v-for="(item, index) in medicinal" :key="index" class="cellstyle" style="padding-top:5px">
            <el-col class="flex2 paddingleft">
              <div style="font-size:small;font-weight: 500;">{{ index + 1 }} 、 {{ item.title }}</div>
              <div class="flex1" style="align-items: center; padding-right: 20px;">
                <el-button type="text" @click="editAlbum1(item)" style="font-size:small;">编辑</el-button>
                <!-- 编辑专辑 -->
                <div style="color:#dadada;padding: 0 3px;">|</div>
                <!-- 删除专辑 -->
                <el-button type="text" @click="delatealbum(item)" style="font-size:small;color: #D03328;">删除</el-button>
              </div>
            </el-col>
            <el-col class="paddingleft-b">
              <span class="tags">{{ item.sub_title }}</span>
            </el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import { number } from "echarts/lib/export";
  import { add } from "zrender/lib/core/vector";
  import http from "../../APIService/http";
  export default {
    name: "album_manage",

    data() {
      return {
        subform: false,
        academicfile: [
          {
            value: "选项1",
            label: "学术资料",
          },
        ],
        academicvalue: "",
        clearValidate: 0,
        isshow: true,
        loading: false,
        timeLineHeight: "",
        rightlibrary: "",
        righttitle: "",
        rightcatlog: "",
        activnum: 0,
        groupname: "",
        albumList: [],
        medicinal: [],
        state1: false,
        library_id: "",
        catalog_id: "",
        dialogVisible1: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        labelPosition: "right",
        // addalbum:{
        //   title:"",
        //   name: "",
        //   explan: "",
        //   sort: "",
        // },
        addgroup: {
          name: "",
          explan: "",
          sort: "",
        },
        rules: {
          name: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          // explan: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          sort: [
            { required: true, trigger: "blur", message: "此项不能为空" },
            { type: "number", message: "排序必须为数字" },
          ],
        },
        rules2: {
          name: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          // explan: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          sort: [
            { required: true, trigger: "blur", message: "此项不能为空" },
            { type: "number", message: "排序必须为数字" },
          ],
          academic: [{ required: true, trigger: "blur", message: "此项不能为空" }],
        },
        rules1: {
          title: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          name: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          // explan: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          sort: [
            { required: true, trigger: "blur", message: "此项不能为空" },
            { type: "number", trigger: "change", message: "排序必须为数字" },
          ],
          academic: [{ required: true, trigger: "blur", message: "此项不能为空" }],
        },
      };
    },
    created() {
      this.newgetAlbumList();
      this.getAlbumByCatalogId();
    },
    mounted() {
      this.timeLineHeight = document.documentElement.clientHeight - 240;
      window.onresize = () => {
        this.timeLineHeight = document.documentElement.clientHeight - 240;
      };
    },
    methods: {
      handleClose() {
        this.$refs["addgroup"].clearValidate();
      },
      clickleft(item, index) {
        this.activnum = index;
        this.righttitle = item.title;
        this.rightcatlog = item.catalog_id;
        this.rightlibrary = item.library_id;
        this.library_id = item.library_id;
        this.catalog_id = item.catalog_id;
        this.getAlbumByCatalogId();
      },

      groupsave() {
        this.saveAlbumGroup();
        this.dialogVisible1 = false;
      },
      editgroup(item) {
        this.catalog_id = "";
        this.catalog_id = item.catalog_id;
        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";
        this.addgroup.name = item.title;
        this.addgroup.explan = item.sub_title;
        this.addgroup.sort = item.sort;
        this.dialogVisible2 = true;
      },
      saveeditgroup() {
        this.editAlbumGroup();
        this.dialogVisible2 = false;
      },
      delategroup(item) {
        this.catalog_id = "";
        this.catalog_id = item.catalog_id;
        this.deleteAlbumGroup();
      },
      addalbum() {
        this.isshow = true;
        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";
        this.dialogVisible3 = true;
      },
      addgroup2() {
        this.isshow = true;
        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";

        this.dialogVisible1 = true;
      },
      editAlbum1(item) {
        this.isshow = true;
        this.catalog_id = "";
        this.catalog_id = item.catalog_id;
        this.addgroup.name = "";
        this.addgroup.explan = "";
        this.addgroup.sort = "";
        this.addgroup.name = item.title;
        this.addgroup.explan = item.sub_title;
        this.addgroup.sort = item.sort;
        this.dialogVisible4 = true;
      },
      delatealbum(item) {
        this.catalog_id = "";
        this.catalog_id = item.catalog_id;
        this.deleteAlbumGroup();
        this.catalog_id = this.rightcatlog;
        this.library_id = this.rightlibrary;
        this.getAlbumByCatalogId();
      },
      canclefun() {
        this.dialogVisible1 = false;
        this.dialogVisible2 = false;
        this.dialogVisible3 = false;
        this.dialogVisible4 = false;
        this.isshow = false;
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      submitForm1(addgroup1) {
        this.$refs[addgroup1].validate((valid) => {
          if (valid) {
            this.groupsave(addgroup1);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      submitForm2(addgroup2) {
        this.$refs[addgroup2].validate((valid) => {
          if (valid) {
            this.editAlbum(addgroup2);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      submitForm3(addgroup3) {
        this.$refs[addgroup3].validate((valid) => {
          if (valid) {
            this.saveAlbum(addgroup3);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      submitForm4(addgroup4) {
        this.$refs[addgroup4].validate((valid) => {
          if (valid) {
            this.editAlbum(addgroup4);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //  编辑专辑组
      async editAlbumGroup() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            catalog_id: this.catalog_id,
            title: this.addgroup.name,
            sub_title: this.addgroup.explan,
            sort: this.addgroup.sort,
          };
          await http.post("/echo/webLibrary/editAlbumGroup", data).then((res) => {
            this.getAlbumList();
          });
        } catch (e) { }
      },
      // 删除专辑组

      async deleteAlbumGroup() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            catalog_id: this.catalog_id,
          };
          await http.post("/echo/webLibrary/deleteAlbumGroup", data).then((res) => {
            this.getAlbumList();
          });
        } catch (e) { }
      },
      // 添加专辑
      async saveAlbum() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            catalog_id: this.rightcatlog,
            title: this.addgroup.name,
            sub_title: this.addgroup.explan,
            sort: this.addgroup.sort,
            photo_id: "",
          };
          await http.post("/echo/webLibrary/saveAlbum", data).then((res) => {
            this.dialogVisible3 = false;
            this.getAlbumByCatalogId();
          });
        } catch (e) { }
      },
      // 编辑专辑

      async editAlbum(type) {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            catalog_id: this.catalog_id,
            title: this.addgroup.name,
            sub_title: this.addgroup.explan,
            sort: this.addgroup.sort,
            library_id: this.library_id,
          };

          await http.post("/echo/webLibrary/editAlbum", data).then((res) => {
            if (type == "addgroup2") {
              this.dialogVisible2 = false;
              this.getAlbumList();
            }
            else if (type == "addgroup4") {
              this.dialogVisible4 = false;
              this.catalog_id = this.rightcatlog;
              this.library_id = this.rightlibrary;
              this.getAlbumByCatalogId();
            }
          });
        } catch (e) { }
      },
      // 左侧数据
      async getAlbumList() {
        this.loading = true;
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          await http.post("/echo/webLibrary/getAlbumList", data).then((res) => {
            this.albumList = res.data;
            // this.library_id = this.albumList[0].library_id;
            // this.catalog_id = this.albumList[0].catalog_id;
            // this.righttitle = this.albumList[0].title;
            // this.rightcatlog = this.albumList[0].catalog_id;
            // this.rightlibrary = this.albumList[0].library_id;
            this.getAlbumByCatalogId();
            this.loading = false;
          });
        } catch (e) {
          this.loading = false;
        }
      },
      async newgetAlbumList() {
        this.loading = true;
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
          };
          await http.post("/echo/webLibrary/getAlbumList", data).then((res) => {
            this.loading = false;
            this.albumList =res.data;
            if (res.data && res.data.length > 0) {
              this.library_id = this.albumList[0].library_id;
              this.catalog_id = this.albumList[0].catalog_id;
              this.righttitle = this.albumList[0].title;
              this.rightcatlog = this.albumList[0].catalog_id;
              this.rightlibrary = this.albumList[0].library_id;
              this.getAlbumByCatalogId();
            }
          });
        } catch (e) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      async getAlbumByCatalogId() {
        this.loading = true;
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            library_id: this.library_id,
            catalog_id: this.catalog_id,
            //   library_id: "b391bbfb-7cd7-4b8f-b254-880a3919df14",
            //   catalog_id: "61a00bbc-858e-4611-a182-fc3e4dde1812",
          };
          await http.post("/echo/webLibrary/getAlbumByCatalogId", data).then((res) => {
            this.medicinal = res.data;
            this.loading = false;
          });
        } catch (e) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      // 新增专辑组
      async saveAlbumGroup() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            title: this.addgroup.name,
            sub_title: this.addgroup.explan,
            sort: this.addgroup.sort,
            user_id: this.$store.getters.getUser.user_id,
            LIBRARY_MATERIAL: this.academicvalue,
          };
          debugger;
          await http.post("/echo/webLibrary/saveAlbumGroup", data).then((res) => {
            if (res.sucess) {
              this.getAlbumList();
            } else {
              this.getAlbumList();
            }
          });
        } catch (e) { }
      },
    },
  };
</script>

<style>
  .paddingleft {
    padding-left: 14px;
    padding-top: 10px;
    padding-right: 14px;
  }

  .paddingleft-b {
    padding: 0 14px;
    padding-top: 5px;
    padding-bottom: 10px;
  }

  .tags {
    background-color: #f5f5f5;
    border-color: #e9e9eb;
    color: #909399;
    border-radius: 3px;
    font-size: 2px;
    padding: 2px;
  }

  .success-text {
    background: #f0faff;
    border-left-style: solid;
    border-color: #1890ff;
  }

  .leftdiv {
    width: 2px;
    background-color: #1890ff;
  }

  .tittle1 {
    font-size: 25px;
    font-weight: bold;
  }

  .flex1 {
    display: flex;
  }

  .flex2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header {
    border-bottom: 1px dashed #e7eaec;
  }

  .formstyle {
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    overflow-y: scroll;
    border-color: #dadada;
    flex: 1;
  }

  .cellstyle {
    border-bottom: 1px solid #ccc !important;
    border-color: #dadada !important;
  }

  #region {
    background: white;
    border: 1px solid #dadada;
    border-left: none;
    padding: 20px 20px;
    height: 100%;
  }

  #region .cell {
    text-align: left;
  }

  #region .el-radio__label {
    display: none;
  }

  #region .el-table {
    margin-top: 35px;
  }

  #region .redact {
    height: 80px;
    font-size: 12px;
    color: #ff9901;
    border: 1px solid #dcdfe6;
    text-align: center;
  }

  #region .redact .el-col {
    user-select: none;
    padding-top: 14px;
    height: 100%;
    border-left: 1px solid #dcdfe6;
  }

  #region .treeBox {
    border: 1px solid #dcdfe6;
    height: 600px;
    border-top: none;
  }

  #region .el-scrollbar {
    height: 95%;
  }

  #region .el-scrollbar__view {
    height: 100%;
  }

  #region .el-tree .filter-tree .el-tree--highlight-current {
    height: 100%;
  }

  #region .el-tree-node .is-expanded .is-current .is-focusable {
    height: 100%;
  }

  #region .el-tree-node__content {
    height: 40px;
  }

  #region .el-tree-node:focus>.el-tree-node__content {
    background-color: #d8f6ee !important;
  }

  #region .icon-t {
    display: inline-block;
    width: 17px;
    height: 18px;
    background: url("../../assets/images/icon-t.png");
  }

  #region .icon-f {
    width: 17px;
    height: 18px;
    background: url("../../assets/images/icon-f.png");
  }

  #region .icon-g {
    width: 17px;
    height: 18px;
    background: url("../../assets/images/icon-g.png");
  }

  #region .el-dialog__close {
    display: none;
  }

  #region .el-form-item__label {
    font-size: 16px;
    color: black;
    text-align: right;
  }

  #region .el-dialog__header {
    border-bottom: 2px dashed #dcdfe6;
    padding: 20px 0 20px 0;
    margin: 20px 20px 10px;
  }

  #region .el-dialog__title {
    font-weight: bold;
    padding-top: 10px;
    padding-left: 10px;
  }

  #region .el-dialog__body {
    padding-right: 100px;
    padding-top: 20px;
  }

  #region .regionUser .el-dialog__body {
    padding-right: 20px;
    padding-top: 20px;
  }

  #region .el-main {
    padding: 0 10px;
  }

  #region .el-select-dropdown__item {
    padding: 0 !important;
  }
</style>
<style scoped>
  #region>>>.region_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }

  #region>>>.region_table_cell {
    color: #2b92fa !important;
  }
</style>
<style scoped>
  .divi>>>.el-divider--horizontal {
    margin: 0;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .style1>>>.el-header {
    padding: 0;
    padding-top: 10px;
    height: 100px;
  }

  .paddingleft-b>>>.el-tag--mini {
    padding: 0;
  }

  /deep/.el-select-dropdown__wrap.el-scrollbar__wrap {
    margin-bottom: 0 !important;
  }
</style>
<style lang="scss">
  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }
</style>


// WEBPACK FOOTER //
// src/pages/echo/album_manage.vue